// removed by extract-text-webpack-plugin
module.exports = {"main-area":"main-area__main-area___m778c","mainArea":"main-area__main-area___m778c","highlighted":"main-area__highlighted___3VBkC"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/main-area.css
// module id = 815
// module chunks = 0